import { render, staticRenderFns } from "./ApprovalCreate.vue?vue&type=template&id=74a7d5bc&scoped=true"
import script from "./ApprovalCreate.vue?vue&type=script&lang=js"
export * from "./ApprovalCreate.vue?vue&type=script&lang=js"
import style0 from "./ApprovalCreate.vue?vue&type=style&index=0&id=74a7d5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a7d5bc",
  null
  
)

export default component.exports